import React, { useState, useEffect } from 'react';
import { getUserCalculationHistory } from '../services/firebase';
import { Link } from 'react-router-dom';
import './HistoryPage.css';

function HistoryPage({ isAuthenticated, userEmail, calculationCount }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchHistory = async () => {
      if (!isAuthenticated || !userEmail) {
        return;
      }
      
      setLoading(true);
      setError('');
      
      try {
        const historyData = await getUserCalculationHistory(userEmail);
        setHistory(historyData);
      } catch (err) {
        console.error('Error fetching history:', err);
        setError('Failed to load calculation history. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchHistory();
  }, [isAuthenticated, userEmail, calculationCount]);

  if (!isAuthenticated) {
    return (
      <div className="history-page">
        <div className="auth-required">
          <h2>Authentication Required</h2>
          <p>Please sign in to view your calculation history.</p>
          <Link to="/" className="back-to-home">Back to Calculator</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="history-page">
      <h1>Your Calculation History</h1>
      <p className="history-subtitle">View and reference your previous Amazon FBA removal fee calculations</p>
      
      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading your calculation history...</p>
        </div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : history.length === 0 ? (
        <div className="no-history">
          <p>You haven't made any calculations yet.</p>
          <Link to="/" className="calculate-button">Make Your First Calculation</Link>
        </div>
      ) : (
        <div className="history-list">
          <div className="history-header">
            <div className="history-cell">Date</div>
            <div className="history-cell">ASIN</div>
            <div className="history-cell">Product</div>
            <div className="history-cell">Size Tier</div>
            <div className="history-cell">Quantity</div>
            <div className="history-cell">Cost</div>
          </div>
          
          {history.map((item, index) => (
            <div key={index} className="history-row">
              <div className="history-cell">
                {new Date(item.date).toLocaleDateString()}
              </div>
              <div className="history-cell">{item.asin}</div>
              <div className="history-cell history-title" title={item.title}>
                {item.title.length > 30 ? `${item.title.substring(0, 30)}...` : item.title}
              </div>
              <div className="history-cell">{item.sizeTier}</div>
              <div className="history-cell">{item.quantity}</div>
              <div className="history-cell">${item.cost.toFixed(2)}</div>
            </div>
          ))}
        </div>
      )}
      
      <div className="history-seo-content">
        <h2>Track Your Amazon FBA Removal Order Costs</h2>
        <p>
          Keep track of all your Amazon FBA removal order fees in one place. Our history feature 
          helps you monitor costs over time and make informed decisions about your inventory management.
        </p>
        <p>
          Whether you're calculating disposal fees or return fees, our calculator provides accurate 
          estimates based on Amazon's current fee structure for standard and oversized items.
        </p>
      </div>
    </div>
  );
}

export default HistoryPage; 